import { createSectionFactory } from "@hydrologiq/shared/createSection"
import { Routing } from "./Routing"
import { section, graphqlUri, restEndpoint, graphqlUriLegacy } from "./config"
import defaultCopy from "./copy"
import { SectionFeatures } from "@hydrologiq/shared/types/sectionFeatures"
import "@fontsource/montserrat"
import { TenantFeatures } from "@hydrologiq/shared/providers/Features"

const localFeatures: TenantFeatures = {
  customer_advanced: false,
  asset_status: false,
  asset_forecast: false,
}

const localSectionFeatures: SectionFeatures = {
  orders: { enabled: false, preview: false },
  deployments: { enabled: false, preview: false },
}

// Create the section using the generic factory
const createSection = createSectionFactory({
  sectionName: "assets",
  section: section,
  RoutingComponent: Routing,
  defaultCopy,
  defaultFeatures: localFeatures,
  graphqlUri,
  restEndpoint,
  // TODO: Add primaryGraphqlUri when hub endpoints are configured
  primaryGraphqlUri: graphqlUri,
  legacyGraphqlUri: graphqlUriLegacy,
  defaultSectionFeatures: localSectionFeatures,
})

export default createSection
